import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

export type OpportunityRelatedExtraGuestSurcharge = {
  age_range__c?: string | null;
  bedding_type__c?: string | null;
  collected_by__c?: string | null;
  extra_guest_type__c?: string | null;
  id: string;
  inclusions__c?: string | null;
  name?: string | null;
  opportunity__c?: string | null;
  other_extra_bedding_type__c?: string | null;
};

export type OpportunityRelatedRecords = {
  extra_guest_surcharges?: Array<OpportunityRelatedExtraGuestSurcharge>;
};

export const opportunityRelatedQueryKeys = {
  all: ['opportunities', 'related'] as const,
  detail: (id: string | undefined) => [...opportunityRelatedQueryKeys.all, id] as const,
};

export function useGetOpportunityRelated(opportunityId: string | undefined) {
  return useQuery({
    queryKey: opportunityRelatedQueryKeys.detail(opportunityId),
    queryFn: async () => {
      if (!opportunityId) {
        throw new Error('opportunityId is required');
      }

      const response = await OffersService.getOpportunityRelated(opportunityId);
      return response.result as OpportunityRelatedRecords;
    },
    enabled: !!opportunityId,
  });
}
